import React, {useState} from "react"
import "../assets/scss/ProsLink.scss";
import TextInput from "../components/TextInput";
import {ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";

export function getLinkAddr(itemText) {
    if (typeof itemText !== 'string') {
        return undefined
    }
    //If text begins with these keywords, consider it as link
    if (itemText.indexOf('http:') === 0 ||
        itemText.indexOf('https:') === 0 ||
        itemText.indexOf('mailto:') === 0 ||
        itemText.indexOf('tel:') === 0
    ) {
        let lines = itemText.split('\n');
        return {
            link: lines.shift(),
            linkText: lines.length >= 1 ? lines.join('\n') : ""
        }
    }
}

export function ProsLinkEditPopup(props) {
    const [link, setLink] = useState(props.link)
    return <>
        <section>
            <TextInput
                label={"Linkki"}
                type={"url"}
                value={link.link}
                onChange={val => setLink({
                    link: val,
                    linkText: link.linkText
                })}
            />
            <Spacer/>
            <TextInput
                label={"Teksti linkille"}
                value={link.linkText}
                multiline={1}
                autoFocus
                onChange={val => setLink({
                    link: link.link,
                    linkText: val
                })}
            />
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <ConfirmButton
                    action={()=> props.saveLink(props.item, link)}
                />
            </div>
        </footer>
    </>
}